"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.starterTierConfig = void 0;
exports.starterTierConfig = {
    hasStarterTier: true,
    showPayoutForm: true,
    showRebrandGuideAndAssetsLink: true,
};
